<template>
  <div
    v-if="isToasterOpen"
    class="toaster"
  >
    <div :class="`content ${toasterVariant}`">
      <div class="text">
        {{ title }}
      </div>
      <img
        class="close-button"
        :src="closeToasterIcon"
        @click="closeToaster"
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import closeToasterIcon from '../../assets/close-toaster.svg';
import useToaster from '../../composables/useToaster';

const { title, isToasterOpen, closeToaster, toasterVariant } = useToaster();

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

  .toaster {
    z-index: 1001;
    position: fixed;
    height: 46px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .content {
      display: flex;
      flex-grow: 1;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      padding: 0 $ri-spacing-m;
      border-radius: 8px;
      color: white;
      box-shadow: 2px 2px 8px rgba(186, 188, 191, 0.25);
      &.info {
        background-color: $riseup_dark_blue_2;
      }
      &.success {
        background-color: $riseup_green;
      }
      &.failure {
        background-color: $riseup_danger_red;
      }
      .close-button {
        cursor: pointer;
      }
    }
  }
@media (min-width: 430px) {
  .toaster {
    margin: calc(100vh*0.05) 0;
    width: 400px;
  }
}

</style>
